import { z } from "zod";

export const FeatureCategory = {
  INVITATION: "invitation",
  MATCHING: "matching",
  COMMUNICATION: "communication",
  INTAKE: "intake",
  EVENT: "event",
  PARTICIPANT: "participant",
  ANALYTICS: "analytics",
  ADMIN: "admin",
  SCHEDULING: "scheduling",
  HOST: "host",
  /** Suggestion generation related features */
  SUGGESTION_GENERATION: "event_grouping",
  AGENTS: "agents",
  DIRECTORY: "directory",
  WORKFLOW: "workflow",
  ENRICHMENT: "enrichment",
  AIMODEL: "aimodel",
} as const;

export const FeatureCategorySchema = z.enum(FeatureCategory);

export type FeatureCategory = z.infer<typeof FeatureCategorySchema>;
